import { render, staticRenderFns } from "./belt.vue?vue&type=template&id=64697400&scoped=true&"
import script from "./belt.vue?vue&type=script&lang=js&"
export * from "./belt.vue?vue&type=script&lang=js&"
import style0 from "./belt.vue?vue&type=style&index=0&id=64697400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64697400",
  null
  
)

component.options.__file = "belt.vue"
export default component.exports